
















































import { Component, Watch, Prop } from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import { RateSourceModule } from '@/store/Products/RateSourceModule';
import Rate from '@/models/Products/Rates/Rate';
import UpdateRateRequest from '@/models/Products/Rates/UpdateRateRequest';

@Component({ name: 'RateEdit' })
export default class extends SaascadaVueDialog {

    dateAsString: string = '';
    rateAsString: string = '0.00';

    @Prop( {required: true})
    rate: Rate;

    @Watch('dialog')
    onDialogChanged(val: boolean, oldVal: boolean) {
        if (val) {
            this.dateAsString = new Date(this.rate.fromDate).toISOString().substr(0,10);
            this.rateAsString = this.rate.rate.toString();
        }
    }

    async save() {
        if (!(this.$refs.form as any).validate()) {
            return;
        }
        else {
            this.dialog = false;
            const request = new UpdateRateRequest();
            request.rateId = this.rate.id;
            request.updatedAt = this.rate.updatedAt;
            request.fromDate = new Date(this.dateAsString + "T00:00:00Z")
            request.rate = parseFloat(this.rateAsString);
            await RateSourceModule.editRateDetails(request);
        }
    }

}
